<template>
  <div class="tw-relative tw-flex tw-flex-col tw-p-8 tw-border tw-border-neutral-300 tw-rounded-xl tw-gap-y-10 tw-max-w-[800px]">
    <div class="tw-absolute tw-top-[-13px] tw-left-1/2 tw-transform tw--translate-x-1/2  tw-border-neutral-300 tw-border-t tw-border-l tw-w-6 tw-h-6 tw-rotate-45 tw-bg-white" />
    <slot />
  </div>
</template>
